import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '../button';
import { Flex } from '../grid';
import { Subheading } from '../typography';

const DownloadButton = ({ heading, href, buttonText, variant }) => (
  <>
    <Subheading mb={1} textAlign="center" variant={2}>
      {heading}
    </Subheading>
    <Flex my={1} justifyContent="center">
      <Button href={href} target="_blank" variant={variant}>
        {buttonText}
      </Button>
    </Flex>
  </>
);

DownloadButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'action', 'link']),
};

DownloadButton.defaultProps = {
  variant: 'secondary',
};

export { DownloadButton };
